import {
  ProgrammInstuctions,
  ProgrammTraining,
  MedicalExaminationDirectory,
} from "@feature/directory-systems";
import { setTitle } from "@store/title-store";
import { TitleProps } from "@store/title-store";
import React, { memo, useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { TabItems } from "@components/common/common";

const DirectorySystems: React.FC = memo(() => {
  const { pathname } = useLocation();
  const TAB_ITEMS: { label: string; path: string; exact?: boolean }[] = [
    {
      label: "Справочник программ обучения",
      path: "/directories/training",
      exact: true,
    },
    {
      label: "Справочник инструктажей",
      path: "/directories/instructions",
      exact: true,
    },
    {
      label: "Медицинские осмотры",
      path: "/directories/medical-examination",
      exact: true,
    },
  ];

  useEffect(() => {
    const newTitle = TAB_ITEMS.find((e) => pathname.indexOf(e.path) !== -1);

    const title = [
      { title: "Главная", href: "/" },
      { title: "Справочники", href: "/directories/training" },
      { title: newTitle?.label, href: pathname },
    ] as TitleProps[];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <main className="content-container">
      <div className="content-section">
        <div className="tab-section">
          <div className="tab-cont">
            <TabItems items={TAB_ITEMS} />
            <div className="tab-content-items">
              <Routes>
                <Route path="/" element={<Navigate to="/directories/training" />} />
                <Route path="/training" Component={ProgrammTraining} />
                <Route path="/instructions" Component={ProgrammInstuctions} />
                <Route path="/medical-examination" Component={MedicalExaminationDirectory} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
});

export default DirectorySystems;
